import { useMediaQuery } from "react-responsive"

const TextGridItem = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { textItemArray } = props

    if (isMobile)
        return (
            <section className="flex col acenter jcenter pad-30 gap-20">

                {
                    textItemArray.map((textItem, index) => {
                        return (
                            <article className="text-grid-card" key={index}>
                                <span className={"text-grid-icon-wrap project-color-" + (index + 1)}>
                                    <i className={textItem[1]}></i>
                                </span>
                                <h2 className="middle-section-title">{textItem[0]}</h2>
                                <p className="text-grid-card-text">{textItem[2]}</p>
                            </article>
                        )
                    })
                }

            </section>
        )
    else
        return (
            <section className="grid-6 gap-20 main-middle-section-2">

                {
                    textItemArray.map((textItem, index) => {
                        return (
                            <article className="text-grid-card" key={index}>
                                <span className={"text-grid-icon-wrap project-color-" + (index + 1)}>
                                    <i className={textItem[1]}></i>
                                </span>
                                <h2 className="middle-section-title">{textItem[0]}</h2>
                                <p className="text-grid-card-text">{textItem[2]}</p>
                            </article>
                        )
                    })
                }

            </section>
        )

}

export default TextGridItem